import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { SBPopularCategoriesAction } from "./sb-popular-categories.action";
import { SBPopularCategoriesResponse } from "./sb-popular-categories.model";
import { SBPopularCategoriesService } from "./sb-popular-categories.service";

@Injectable()
export class SBPopularCategoriesEffect {
	getSBPopularCategories$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SBPopularCategoriesAction.fetchAll),
			switchMap(({ quickLinks$ }) =>
				this.sbPopularCategoriesService.getAllPopularCategories().pipe(
					map((categories: SBPopularCategoriesResponse) =>
						SBPopularCategoriesAction.fetchAllSuccess(categories, quickLinks$)
					),
					catchError((error: AppError) => of(SBPopularCategoriesAction.fetchAllFail(error)))
				)
			)
		)
	);

	sbPopularCategoriesQuickLinks$ = createEffect(() =>
		this.actions$.pipe(
			ofType(SBPopularCategoriesAction.fetchAllSuccess),
			switchMap(({ quickLinks$, categories }) =>
				this.sbPopularCategoriesService
					.transformToQuickLinks$$(categories.items, quickLinks$)
					.pipe(map((quickLinks) => SBPopularCategoriesAction.transformToQuickLinksSuccess(quickLinks)))
			)
		)
	);

	constructor(
		private actions$: Actions,
		private sbPopularCategoriesService: SBPopularCategoriesService
	) {}
}
